const StaffPickLaneType = {
	byStaffMember: 'byStaffMember',
	bySection: 'bySection',
};

export default StaffPickLaneType;
